import { inject, Injectable } from '@angular/core';

import { PriorityNewsItem } from '../../../shared/interfaces';
import { SignageConfigurationModel } from '../../config/models';
import { RuntimeSlideModel } from '../../slides/models';
import { SlideDurationPolicyService } from '../../slides/slide-duration-policy.service';
import { BuildContextModel, FetchContextModel } from '../models';
import { ContentProvider } from '../interfaces';
import { ContentKind, SlideLayout } from '../../slides/enums';
import { PresentationSlot } from '../enums';
import { RefreshTier } from '../../config/enums';

@Injectable()
export class PriorityNewsContentProvider implements ContentProvider<PriorityNewsItem> {
  private readonly duration = inject(SlideDurationPolicyService);

  public readonly kind = ContentKind.PriorityNews;
  public readonly tier = RefreshTier.Secondary;
  public readonly order = 50;
  public readonly presentation = PresentationSlot.Overlay;

  public isEnabled(config: SignageConfigurationModel): boolean {
    return config.enabled[this.kind] === true;
  }

  public fetch(context: FetchContextModel): Promise<PriorityNewsItem[]> {
    return context.source.loadPriorityNews(context.config.channel, context.signal);
  }

  public toSlides(items: PriorityNewsItem[], context: BuildContextModel): RuntimeSlideModel[] {
    return items.map((item): RuntimeSlideModel => ({
      id: `priority-news:${item.id}:overlay`, kind: this.kind, layout: SlideLayout.Fullscreen,
      content: {
        id: item.id, providerChannelIds: [], priority: item, title: item.subject,
        bodyText: item.bodyContent?.text || ''
      },
      duration: this.duration.timingFor(item.bodyContent?.text || '', context.config), meta: { sourceId: item.id }
    }));
  }
}
